<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <StaticViewHeading icon="tune" subtitle="Configuración global que condiciona el funcionamiento del software" />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions"><TabHeaderActions :show-shortcut="false" /></div>
          </div>
        </section>
      </b-card>

      <b-card no-body>
        <b-table class="app-table"
              responsive="sm"
              :hover="true"
              :small="true"
              :fixed="false"
              :items="table.items"
              :fields="tableFields"
              :stacked="isMobileViewport ? 'md' : false"
              v-if="table.items.length">

              <template v-slot:cell(value)="data">
                <b-badge variant="success" class="badge-module-permissions-custom" v-if="data.item.value">Activado</b-badge>
                <b-badge variant="danger" class="badge-module-permissions-custom" v-else>Inactivo</b-badge>
              </template>

              <template v-slot:cell(f_action)="data">
                <b-dropdown right no-caret size="sm" variant="link" boundary="window" toggle-class="app-table-action-toggle">
                  <template #button-content><AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" /><span v-if="isMobileViewport" class="app-table-action-label">Opciones</span></template>
                  <b-dropdown-item @click="configurateConfirm(data.item)" v-if="!data.item.value">
                    <AppIcon name="check" class="text-success mr-1" /> Activar
                  </b-dropdown-item>
                  <b-dropdown-item @click="configurateConfirm(data.item)" v-if="data.item.value">
                    <AppIcon name="block" class="text-danger mr-1" /> Desactivar
                  </b-dropdown-item>
                </b-dropdown>
              </template>
        </b-table>
        <EmptyState v-else icon="tune" title="No se encontraron parámetros" description="No hay parámetros globales disponibles para configurar." />
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import StaticViewHeading from '@/components/inc/module/StaticViewHeading'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: { StaticViewHeading, TabHeaderActions },
    data: () => {
      return {
        table : {
          items: [],
          fields: [
            {key: 'id', label: 'ID'},
            {key: 'description', label: 'Descripción'},
            {key: 'value', label: 'Activado'},
            {key: 'f_action', label: ''},
          ],
        },
        arr: {
          parametrs: [],
        },
        isMobileViewport: false,
      }
    },
    mounted() {
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.cargar()
    },
    beforeDestroy() {
      if (this.mobileMql) this.mobileMql.removeEventListener('change', this.updateMobileViewport)
    },
    computed: {
      tableFields () {
        return this.table.fields.map(field => field.key === 'f_action' ? Object.assign({}, field, { label: this.isMobileViewport ? 'Acción' : '', thClass: 'align-middle' }) : field)
      },
    },
    methods: {
      updateMobileViewport (event) {
        this.isMobileViewport = event.matches
      },
      cargar () {
        let loader = this.$loading.show();
        var result = serviceAPI.obtener()

        result.then((response) => {
          var data = response.data
          this.table.items = data
          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });
      },
      configurateConfirm(item) {
        this.$bvModal.msgBoxConfirm('¿Desea cambiar el estado de este registro ID >> ' + item.id + '?', {
          title: 'Borrar Usuario',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: "dark",
          headerTextVariant: "white",
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {
          if (value) {
            this.configurate(item)
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      configurate(item) {
        let loader = this.$loading.show();

        var data ={ id: item.id, value: !item.value}
        var result = serviceAPI.configurar(data);

        result.then(() => {
          var result1 = serviceAPI.obtenerParametros()

          result1.then((response1) => {
            var data = response1.data

            Session.setSessionParameters(data);
            loader.hide()
            this.cargar()
            this.$awn.success("Parametro configurado con éxito");
          })
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
    }
  }
</script>
<style>
  .badge-module-permissions-custom {
    font-size: 14px;
  }
</style>
